module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_container"
  }, [_c('div', {
    staticClass: "download_content"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "download_btn"
  }, [_c('ul', {
    staticClass: "download"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-android"
  }), _vm._v("Android版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v("iPhone版")])])]), _vm._v(" "), _c('div', {
    staticClass: "download_img1"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "share_list"
  }, [_c('li', [_vm._v("关注我们")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-qq"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-weibo"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-wechat"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "app-img"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d39d6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download.vue
// module id = 63
// module chunks = 0